import { call } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import i18n from 'i18n';

export function* displayToastrFromSaga(translationKey, toastrType = toastr.success, toastrOptions = {}) {
    yield call(toastr.clean);
    yield call(toastrType, '', i18n.t(translationKey), toastrOptions);
}
